import boundingBoxes from '../country-bounding-boxes.json';

export const SINGLE_COUNTRY_BOUNDS_PADDING = 0.8;

// A lone point would otherwise frame as a zero-area box, which fitBounds reads
// as "zoom in as far as you can go".
const SINGLE_POINT_BOUNDS_SPAN = 1;

export const padCountryBounds = (
    bounds,
    padding = SINGLE_COUNTRY_BOUNDS_PADDING
) => {
    if (!bounds) {
        return null;
    }

    return [
        bounds[0] - padding,
        bounds[1] - padding,
        bounds[2] + padding,
        bounds[3] + padding,
    ];
};

export const getCountryBounds = (countryCode) =>
    (countryCode && boundingBoxes[countryCode.toUpperCase()]?.[1]) || null;

/** The box spanning a GeoJSON point collection, or null if it holds none. */
export const getPointsBounds = (points) => {
    const features = points?.features;

    if (!features?.length) {
        return null;
    }

    const longitudes = features.map((f) => f.geometry.coordinates[0]);
    const latitudes = features.map((f) => f.geometry.coordinates[1]);

    const spread = (values) => {
        const min = Math.min(...values);
        const max = Math.max(...values);
        const halfSpan = SINGLE_POINT_BOUNDS_SPAN / 2;

        return min === max ? [min - halfSpan, max + halfSpan] : [min, max];
    };

    const [west, east] = spread(longitudes);
    const [south, north] = spread(latitudes);

    return [west, south, east, north];
};
